import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * tailwind-merge has to be told the type scale. It only knows Tailwind's
 * default size names, so it reads `text-body` as a *colour* and drops it
 * whenever a real colour like `text-on-accent` follows — every button was
 * rendering at the inherited 16px instead of 17. The names here are the
 * `--text-*` tokens in tokens.css; keep the two in step.
 */
const twMerge = extendTailwindMerge({
  override: {
    theme: { text: ["title", "body", "meta"] },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
